<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        WebShell Detail
        </h4>
        <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
            <a href="#">
              <i class="fas fa-home text-muted"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <a class="font_15 font-weight-bold" href="#">WebShell Detail</a>
          </li>
        </ul>
      </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              Sumitted Detail
            </div>
            <div class="mb7">
              <span class="float-right"> {{model.created_at | datetime}}</span>
            </div>
          </div>
          <hr>
          <b-row class="row mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_status">
                Status
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 mt-3">
              <!-- <b-badge variant="success" v-if="model.is_done">applyed</b-badge>
              <b-badge v-else variant="secondary">Wait</b-badge> -->
              <b-badge v-if="model.is_del" variant="danger">Deleted</b-badge>
              <b-badge v-else :variant="model.is_done ? 'success' : 'secondary'">{{model.is_done ? 'Applyed' : 'Wait'}}</b-badge>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_source">
                Source [Regist request user]
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <div v-if="model && model.source">{{model.source}}</div>
            </b-col>
          </b-row>
          <b-row class="row mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_type">
                Content Type
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <div v-if="model && model.category" v-html="model.category"></div>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_ext">
                Content Extension
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <div v-if="model && model.ext" v-html="model.ext"></div>
            </b-col>
          </b-row>
          <b-row class="row mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_filename">
                FileName
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <div v-if="model && model.name" v-html="model.name"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-xl-12 col-md-12">
              <b-button class="float-right" size="sm" variant="warning" @click="decrypt" :disabled="decrypted">
                Force Decode base64
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
            <b-form-group>
              <hr>
              <label for="ph_descript">Content</label>
              <span v-if="model && model.length">( bytes : {{model.length}} )</span>
              <div v-if="model && model.data" v-html="content || model.data || 'None'" style="padding:15px;background:#f5f5f5;border:1px solid #ccc;border-radius:5px;"></div>
            </b-form-group>
            </b-col>
          </b-row>
          <b-form>
            <b-button size="sm" variant="danger" @click="remove_confirm = true" style="margin:0 5px;" :disabled="model.is_del"> Remove </b-button>
            <b-button size="sm" variant="add" @click="regist_confirm = true" style="margin:0 5px;" :disabled="model.is_del"> Pattern Regist </b-button>
            <b-button size="sm" variant="primary" @click="download" style="margin:0 5px;"> Download </b-button>
            <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Webshell Regist"  class="modal-danger" v-model="remove_confirm" @ok="remove" ok-variant="outline-danger" cancel-variant="outline-dark" header-bg-variant="danger">
      Would You Like to delete?
    </b-modal>
    <b-modal title="Webshell Regist"  class="modal-warning" v-model="regist_confirm" @ok="add" ok-variant="outline-warning" cancel-variant="outline-dark" header-bg-variant="warning">
      Would You Like to Regist?
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>